export default class LightBox
{
  constructor($el)
  {
    this.el = $el;
    this.title = this.el.find('.title');
    this.contentWrap = this.el.find('.images');
    this.pagination = this.el.find('.pagination');
    this._content = null;
    this._numSlides = 0;
    this._activeSlide = 1;
    this._contentTitle = '';

    this.handleControls = this.handleControls.bind(this);
    this.onImagesChanged = this.onImagesChanged.bind(this);
    this.init();
  }

  get content() { return this._content; }
  set content(el)
  {
    if (el instanceof jQuery) {
      this.contentWrap.html(el);
      this._content = el;
      this.numSlides = el.find('li').length;
      this.content.find('li:first-child').addClass('active');
      this._contentTitle = el.data('title');
      this.title.text(this._contentTitle);
    }
  }

  get numSlides() { return this._numSlides; }
  set numSlides(n)
  {
    this._numSlides = n;
    this.updatePagination();
  }

  get activeSlide() { return this._activeSlide; }
  set activeSlide(n)
  {
    let updated = n;
    if (n > this.numSlides) {
      updated = 1;
    } else if (n <= 0) {
      updated = this.numSlides;
    }
    this._activeSlide = updated;

    if (this.content instanceof jQuery) {
      this.content.children().removeClass('active');
      const slide = this.content.find(`li:nth-child(${this.activeSlide})`).addClass('active');
      if (slide.data('title')) {
        this.title.text(slide.data('title'));
      } else {
        this.title.text(this._contentTitle);
      }
    }

    this.updatePagination();
  }

  init()
  {
    this.el.find('.controls > a').click(this.handleControls)
    this.el.on('images_changed', this.onImagesChanged)
  }

  handleControls(e)
  {
    e.preventDefault();

    let anchor = e.target;
    if (anchor.nodeName.toLowerCase() !== 'a') {
      anchor = e.target.parentElement;
    }

    switch (anchor.hash) {
      case '#prev':
        this.activeSlide--;
        break;
      case '#next':
        this.activeSlide++;
        break;
      case '#close':
        this.close();
        break;
    }

    return false;
  }

  onImagesChanged()
  {
    this.content = this.el.find('.images').children();
  }

  updatePagination()
  {
    this.pagination.text(`${this.activeSlide}/${this.numSlides}`);
  }

  open()
  {
    if (this.content !== null) {
      jQuery('body').addClass('lightbox-active');
    }
  }
  close()
  {
    jQuery('body').removeClass('lightbox-active');
    this.activeSlide = 1;
  }
}